export function EmptyCell() {
  return <span className="text-xs text-muted-foreground">N/A</span>;
}
